import React from 'react'

function Cor() {
  return (
    <div>Cor</div>
  )
}

export default Cor